module.exports = __webpack_public_path__ + "img/store_select.ab563a11.png";